import { render, staticRenderFns } from "./MyUserBudgetLimitsList.vue?vue&type=template&id=1840f0ce&scoped=true"
import script from "./MyUserBudgetLimitsList.vue?vue&type=script&lang=js"
export * from "./MyUserBudgetLimitsList.vue?vue&type=script&lang=js"
import style0 from "./MyUserBudgetLimitsList.vue?vue&type=style&index=0&id=1840f0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840f0ce",
  null
  
)

export default component.exports